import { baseUrl, loginUrl } from 'lowcode/utils/service/baseUrl';
import { fetchPost } from 'lowcode/utils/service/FetchClient';
import getIgnoreTokenHeader from 'lowcode/utils/service/getIgnoreTokenHeader';

// 根据变体ID获取产品列表
export const getShopifyProductList = async (locale: string, variantIds: string[]) => {
    const res = await fetchPost(
        `${baseUrl(locale)}/ProductCaculation/productInfoList`,
        locale,
        {
            variantIds,
        },
        {
            headers: {
                ...getIgnoreTokenHeader(),
            },
        },
    );
    if (res?.code === '0') {
        return res?.data || [];
    }
    return [];
};

// 根据变体ID获取产品列表-新
export const shopifyProductVariantSelectById = async (locale: string, variantIds: string[]) => {
    const res = await fetchPost(`${loginUrl(locale)}/shopify/web/shopifyProductVariant/selectById`, locale, {
        productVariantIds: variantIds,
    });
    if (res?.code === '0') {
        return res?.data || [];
    }
    return [];
};
